import React from 'react';
import Stack from '@mui/material/Stack';
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import BackArrowSvgIcon from "@resource/BackArrowSvgIcon";
import {sx} from './sx'
import NameInfoBackBarSingleVoyage from "@containers/singleVoyage/views/backBar/nameInfo/NameInfoBackBarSingleVoyage";
import {useNavigate} from 'react-router-dom';


interface IProps {
    name?: string,
}

const BackBarSingleVoyage = ({name}: IProps) => {
    const navigate = useNavigate();
    const onBack = () => {
        navigate(-1)
    }
    return (
        <Stack
            gap={'8px'}
            alignItems={'center'}
            direction={'row'}
        >

            <IconButtonCustom
                variant={'empty'}
                sx={sx.btn}
                onClick={onBack}
            >
                <BackArrowSvgIcon/>

            </IconButtonCustom>


            {name && <NameInfoBackBarSingleVoyage name={name}/>}

        </Stack>
    );
};

export default BackBarSingleVoyage;